<template>
  <div class="tabs_content">
    <section>
      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="vod-providers-packages">
          <table class="vypis">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <th><span class="name" v-translate>Název</span></th>
              <th><span class="name" v-translate>Typ balíčku</span></th>
            </tr>
            </thead>
            <tbody>
            <PackageRow v-for="entity in entities"
                        :entity="entity"
                        :key="entity.id"
                        ref="packages_row"
                        :selectedEntities="selectedEntities"
                        @input="select"/>
            <tr v-if="entities.length === 0">
              <td colspan="5" v-translate>Nebyly nalezeny žádné balíčky videí.</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <local-list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          table-id="vod-providers-packages"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
      ></local-list-action-line>
    </section>
  </div>
</template>

<script>
import localTable from "@/components/mixins/local-table"
import PackageRow from "./PackagesRow.vue";

export default {
  name: "Packages",
  components: {PackageRow},
  mixins: [localTable],
  props: {
    entity: Object
  },
  data(){
    return {
      tabName: "packages",
    }
  },
  computed: {
    entities(){
      return this.entity.packages;
    },
    csvHeaders(){
      return {
        'name': {name: this.$gettext('Název')},
        'type': {name: this.$gettext('Typ balíčku')},
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodProviders/detail/Packages.vue